import React from "react";
import { Outlet, Navigate, useSearchParams } from "react-router-dom";
import Breadcrumb from "../components/common/breadcrumb";


const Error404 = React.lazy(() => import("../components/errors/error404"));

function CompanyLayout() {
  /**
   * Data retrieved from the Redux store for token role
   * @type {any}
   */
  const token = localStorage.getItem("admin_token") || null;
  const company_id = localStorage.getItem("company_id") || null;
  const authority = Number(localStorage.getItem("authority")) || null;

  const [searchParams] = useSearchParams();
  const tabno = parseInt(searchParams.get("tabno")) || 0;
  const breadcrumbData = (() => {
    if (tabno === 0) {
      return [{ label: "企業", href: "", clickable: false }];
    }
    if (tabno === 1) {
      const crumbs = [
        {
          label: "アカウント",
          href: "",
          clickable: false,
        },
      ];
      return crumbs;
    }
  })();

  return (
    <>
      {token && (authority === 1 || authority === 4) ? (
        <div id="wrapper" className="d-flex flex-column min-vh-100 grey_bgs">
          <div id="content-wrapper">
            <div id="content">
              <div className="container-fluid header-enterprise">
                <div className="row">
                  <div className="col-md-6">
                    <p><Breadcrumb breadcrumbData={breadcrumbData} /></p>
                    <div className="col-pd">
                    {authority !== 1 ? (
                      <h1 className="heading2" style={{marginBottom:'25px'}}>企業</h1>
                    ) : (
                      <h1 className="heading2" style={{marginBottom:'25px'}}>ワークショップ管理</h1>
                    )}
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="container-fluid "> */}

              <Outlet />
              {/* </div> */}
            </div>
          </div>
        </div>
      ) : token && authority === 2 ? (
        <Navigate to={"/companies/" + company_id + "/workshops"} replace />
      ) : !token ? (
        <Navigate to={"/login"} replace />
      ) : (
        <Error404 />
      )}
    </>
  );
}

export default CompanyLayout;
